import { makeStyles } from '@mui/styles'

export default makeStyles((theme) => ({
  overlay: {
    backgroundColor: 'white',
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
  },
  centerTitle: {
    margin: 'auto',
    width: 500,
    textAlign: 'center',
    marginTop: 250,
  },
  container: {
    display: 'flex',
    flex: 1,
    maxHeight: 'auto',
  },
  infoContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  imageContainer: {
    margin: 'auto',
    marginTop: 20,
    marginLeft: 20,
    marginRight: 20,
    marginBottom: 20,
    minHeight: 150,
    height: 'auto',
    maxHeight: 500,
    border: 'solid gray',
    boxShadow: `0.1em 0.1em 0.5em rgb(64, 64, 70)`,
    borderRadius: 10,
  },
  image: {
    height: '100%',
    width: '100%',
    maxWidth: 5000,
    maxHeight: 500,
    minHeight: 150,
    border: 'solid gray 1px',
    borderRadius: 10,
  },
  label: {
    fontWeight: 'bold !important',
    marginRight: '10px !important ',
  },
  resultContainer: {
    padding: 20,
    flex: 1,
  },
}))
